export * from "./CatMedicalCard";
export * from "./CatMedicalCard.config";
